// 게임 시스템 조율 클래스
class GameCoordinator {
  constructor(game) {
    this.game = game;
  }

  // 스폰 시스템 초기화 (단일 진입점) - 스테이지 시스템 사용
  initSpawns() {
    if (!this.game.spawnScheduler) {
      return;
    }

    try {
      // 한국어 주석: 스케줄러를 완전히 초기화한 후 스테이지 시작
      this.game.spawnScheduler.start(); // 게임 시간, 스테이지, 이벤트 모두 리셋
      this.game.spawnScheduler.startStage(0); // 스테이지 0부터 시작
    } catch (error) {
      Utils.log("스폰 시스템 초기화 실패:", error);
    }
  }

  // 스폰 스케줄러 정지
  stopSpawnSystem() {
    if (this.game.spawnScheduler) {
      this.game.spawnScheduler.stop();
    }
  }

  // 모든 적 제거
  removeAllEnemies() {
    // 새로운 적들 제거
    if (this.game.enemySpawnManager) {
      this.game.enemySpawnManager.removeAllEnemies();
    }
  }
}

// webpack 빌드를 위해 default export 추가
export default GameCoordinator;
